import React, { ReactNode } from 'react'
import { useApplicationContext } from '../../../provider'

interface ExperimentHocPropType {
  children: ReactNode
  experimentName: string
  control?: boolean
}

/**
 * Use this <ExperimentHoc> in MDX file to show content if we are in certain 'name' experiment
 * i.e. <ExperimentHoc experimentName='integrationBuilder'>Show Integration Builder</ExperimentHoc>
 *
 * For if/else condition when the experiment is on or off, you can use it like this
 *   <ExperimentHoc experimentName='A'>If case</ExperimentHoc>
 *   <ExperimentHoc experimentName='A' control>Else clause</ExperimentHoc>
 */
const shouldShowContent = (
  experimentValue: string,
  control: boolean,
): boolean => {
  if (!experimentValue) return true // No experiment, show content

  const isControl = experimentValue.startsWith('Ctrl_')
  const isTreatment = experimentValue.startsWith('Trmt_')

  if (control) {
    return isControl
  }

  // For non-control components, show for treatment or control (fallback)
  return isTreatment || isControl
}

const handleIntegrationBuilderExperiment = (
  experiments: any,
  control: boolean,
): boolean => {
  const treat1 = experiments.integrationBuilder || ''
  const treat2 = experiments.integrationBuilderKBYC || ''

  if (control) {
    return treat1.startsWith('Ctrl_') && treat2.startsWith('Ctrl_')
  }

  return treat1.startsWith('Trmt_') || treat2.startsWith('Trmt_')
}

export const ExperimentHoc = ({
  children,
  experimentName,
  control = false,
}: ExperimentHocPropType): JSX.Element => {
  const { experiments } = useApplicationContext()

  let shouldShow = false

  if (experimentName === 'integrationBuilder') {
    shouldShow = handleIntegrationBuilderExperiment(experiments, control)
  } else {
    const experiment = experiments[experimentName] || ''
    shouldShow = shouldShowContent(experiment, control)
  }

  return shouldShow ? <>{children}</> : <></>
}

export default ExperimentHoc
